if (window.giftLevels) {
	document.addEventListener('DOMContentLoaded', function () {
		const url = window.location.href;
		const baseUrl = window.location.origin;
		if (url.includes('/cart')) {
			window.location.href = baseUrl;
		}
		const isGift = document.querySelector('[is-gift]');
		if (isGift) {
			window.location.href = baseUrl;
		}
	});
}
